/*
 * Old URLs of the current site that must keep working (P15, ROUTES §3, Decision 26), wired from router.tsx:
 * redirects (`/index`, `/user/reservations`), the sign-in `redirectTo` alias and the experiences query
 * (`/activities?city=&date=&categoryId=` from e-mails and cross-sell links).
 */
import { redirect, type LoaderFunctionArgs } from 'react-router';

/** Loader redirecting to `to`, the query string kept. */
export const redirectTo =
  (to: string) =>
  ({ request }: LoaderFunctionArgs) => {
    const { search } = new URL(request.url);
    return redirect(`${to}${search}`);
  };

/** Sign-up and sign-in of the old site read `?redirectTo=`; the new pages read `?redirect=`. */
export function redirectToAlias({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const legacy = url.searchParams.get('redirectTo');
  if (legacy === null) return null;
  url.searchParams.delete('redirectTo');
  if (!url.searchParams.has('redirect')) url.searchParams.set('redirect', legacy);
  return redirect(`${url.pathname}?${url.searchParams}`);
}
